module.exports = __webpack_public_path__ + "media/alien.19f42056.mp3";